const property = require('lodash/property');
const map = require('lodash/map');
const moment = require('moment');

const app = angular.module('msi.subscriptions.subscriptionService', [
  require('@ordergroove/brandy/src/app/utils'),
  require('@ordergroove/brandy/src/app/core/constants'),
  require('../cancel/cancel-reason.domain')
]);

const injects = [
  'apiService',
  'caseConversionService',
  'CancelReason',
  'ogsdk.subscriptionService',
  'sspcConfig',
  '$q'
];

function SubscriptionService(apiService, caseConversionService, CancelReason, subscriptionService, sspcConfig, $q) {
  // getSubscriptions is now in ogsdk.subscriptions.getAll

  // getSubscription is now subscriptionService.get


  this.getCancelReasons = () => {
    if (sspcConfig.cancelReasons) {
      const reasons = sspcConfig.cancelReasons.map(reason => new CancelReason(reason));
      return $q.resolve(reasons);
    }

    return apiService.get('/merchant/cancel_reason/', { params: { application: 'msi' } })
      .then(property('results'))
      .then((reasons) => {
        return map(reasons, (reason) => {
          return new CancelReason(reason);
        });
      });
  };

  this.setFrequency = function(subscription, freq) {
    return subscriptionService.changeFrequency(subscription.publicId, freq);
  };

  this.reactivateSubscription = (subscription) => {
    return subscriptionService.reactivate(subscription.publicId, {
      every: subscription.frequency.every,
      period: subscription.frequency.period,
      startDate: moment().add(1, 'day').toDate()
    });
  };

  this.setShipping = function(subscriptionId, addressId) {
    return subscriptionService.changeShippingAddress(subscriptionId, addressId);
  };

  this.setPayment = function(subscriptionId, paymentId) {
    return subscriptionService.changePayment(subscriptionId, paymentId);
  };

  this.changeNextOrderDate = function(subscriptionId, _nextOrderDate_) {
    const nextOrderDate = moment(_nextOrderDate_).format('MM/DD/YYYY');
    const url = `/subscription/${subscriptionId}/change_next_order_date/${nextOrderDate}`;
    return apiService.paramAuth.get(url);
  };
}

SubscriptionService.$inject = injects;

app.service('subscriptionService', SubscriptionService);

module.exports = app.name;
